<template>
    <div class="absolute inset-0 z-10 bg-white -mx-4">
        <div class="text-center flex flex-col justify-center items-center my-40">
            <span class="inline-flex items-end gap-[2px] text-6xl text-pink-600">
                <span class="animate-dot-1">.</span>
                <span class="animate-dot-2">.</span>
                <span class="animate-dot-3">.</span>
            </span>
            <template v-if="message">
                <div class="text-xl md:text-xl font-semibold text-gray-700 leading-tight my-3 animate-pulse">
                    {{ $t(message) }}
                </div>
            </template>
        </div>
    </div>
</template>

<script setup>
defineProps({
    color: {
        type: String,
        default: '#b8004b'
    },
    message: {
        type: String
    }
})
</script>
